"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Tab_1 = __importDefault(require("@/Components/common/Tab"));
var react_admin_1 = require("react-admin");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var PlayerDetailsGeneralTab_1 = __importDefault(require("@/Components/Players/PlayerDetailsGeneralTab"));
var PlayerDetailsAdvancedTab_1 = __importDefault(require("@/Components/Players/PlayerDetailsAdvancedTab"));
var PlayerDetailsInfoTab_1 = __importDefault(require("@/Components/Players/PlayerDetailsInfoTab"));
var PlayerDetailsLocationTab_1 = __importDefault(require("@/Components/Players/PlayerDetailsLocationTab"));
var PlayerDetailsNetworkTab_1 = __importDefault(require("@/Components/Players/PlayerDetailsNetworkTab"));
var Players_module_css_1 = __importDefault(require("./Players.module.css"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var front_end_validation_1 = __importDefault(require("@nordicscreen/front-end-validation"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var BlackScreenSchedule_1 = __importDefault(require("./BlackScreenSchedule"));
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var EditablePlayerName = function (_a) {
    var player = _a.player, permissions = _a.permissions, resourceType = _a.resourceType;
    var logger = q_play_core_1.logManager.getLogger();
    var refresh = (0, react_admin_1.useRefresh)();
    var _b = (0, react_1.useState)(false), showTitleEdit = _b[0], setShowTitleEdit = _b[1];
    var _c = (0, react_1.useState)(false), showTitleBorder = _c[0], setShowTitleBorder = _c[1];
    var _d = (0, react_1.useState)(player.name), playerName = _d[0], setPlayerName = _d[1];
    var _e = (0, react_1.useState)(""), playerNameError = _e[0], setPlayerNameError = _e[1];
    var playerNameErrorDebouncer = (0, react_1.useState)(new q_play_core_1.Debouncer(function () {
        try {
            new front_end_validation_1.default(player.name)
                .validate("should.have.maxLength", "The player name is too long", "255")
                .and("should.have.minLength", "The player name is too short", "1")
                .check();
            setPlayerNameError("");
        }
        catch (e) {
            if (e[0] !== undefined) {
                logger.error(e[0].message);
                setPlayerNameError(e[0].message);
            }
            else {
                logger.error(e[1].message);
                setPlayerNameError(e[1].message);
            }
        }
    }, 500))[0];
    (0, react_1.useEffect)(function () {
        playerNameErrorDebouncer.debounce();
    });
    var inputTitleStyles = {
        borderBottom: showTitleBorder ? "1px solid #BABABA" : "0px",
        outline: "none",
        background: "#F7F7F7",
    };
    var playerNameStyle = {
        marginTop: "-50px",
        marginBottom: "10px"
    };
    var changeTitleField = function () {
        if (!showTitleBorder) {
            setShowTitleEdit(false);
        }
    };
    var savePlayerNameHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!playerNameError && player.name.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, ApiManager_1.default.updatePlayerName(Number(player.id), playerName).then(function () {
                            refresh();
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "col-6 d-flex align-items-center", style: playerNameStyle },
        react_1.default.createElement(AccessControl_1.default, { resourceId: player.id, resourceType: resourceType, conditionalChildren: [
                {
                    permission: __spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true),
                    children: (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { onMouseEnter: function () { return setShowTitleEdit(true); }, onMouseLeave: changeTitleField }, showTitleEdit ? (react_1.default.createElement("input", { className: "".concat(Players_module_css_1.default.player_details_modal_header, " border-top-0 border-start-0 border-end-0"), style: inputTitleStyles, value: playerName, type: "text", onFocus: function (event) {
                                setShowTitleBorder(true);
                                setTimeout(function () { return event.target.select(); }, 0);
                            }, onBlur: function () {
                                setShowTitleBorder(false);
                                setShowTitleEdit(false);
                                savePlayerNameHandler();
                                setPlayerName(playerName);
                            }, onChange: function (event) { return setPlayerName(event.target.value); }, "data-cy": "playerNameInput" })) : (react_1.default.createElement("input", { className: "".concat(Players_module_css_1.default.player_details_modal_header, " border-0"), value: playerName, type: "text", readOnly: true }))),
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPen, color: "var(--primary-color)", style: { fontSize: "15px" } })))
                },
                {
                    permission: permissions.read,
                    children: (react_1.default.createElement("input", { className: "".concat(Players_module_css_1.default.player_details_modal_header, " border-0"), value: playerName, type: "text", readOnly: true }))
                }
            ] })));
};
var PlayerDetailsModal = function (_a) {
    var isShown = _a.isShown, toggle = _a.toggle, player = _a.player, active = _a.active, setActiveProp = _a.setActiveProp, toggleAddPresentations = _a.toggleAddPresentations, toggleAddEvents = _a.toggleAddEvents, toggleAddMetadata = _a.toggleAddMetadata, toggleConfirmationModal = _a.toggleConfirmationModal, permissions = _a.permissions, resourceType = _a.resourceType;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    (0, react_1.useEffect)(function () {
        setActiveProp("PlayerDetailsGeneralTab");
    }, [isShown]);
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: isShown, onClose: toggle, dialogClassName: Players_module_css_1.default.modalDialog, centered: true, body: react_1.default.createElement("div", null,
            react_1.default.createElement(EditablePlayerName, { player: player, permissions: permissions, resourceType: resourceType }),
            react_1.default.createElement("div", { className: Players_module_css_1.default.tabs },
                react_1.default.createElement(Tab_1.default, { value: "PlayerDetailsGeneralTab", onClick: function () { return setActiveProp("PlayerDetailsGeneralTab"); }, text: t("General"), active: active === "PlayerDetailsGeneralTab", dataCy: "playerDetailsGeneralTab" }),
                react_1.default.createElement(Tab_1.default, { value: "PlayerDetailsAdvancedTab", text: t("Advanced"), onClick: function () { return setActiveProp("PlayerDetailsAdvancedTab"); }, active: active === "PlayerDetailsAdvancedTab", dataCy: "playerDetailsAdvancedTab" }),
                react_1.default.createElement(Tab_1.default, { value: "PlayerDetailsInfoTab", text: t("Player Info"), onClick: function () { return setActiveProp("PlayerDetailsInfoTab"); }, active: active === "PlayerDetailsInfoTab" })),
            active === "PlayerDetailsGeneralTab" ? react_1.default.createElement(PlayerDetailsGeneralTab_1.default, { player: player, toggleAddPresentations: toggleAddPresentations, toggleAddEvents: toggleAddEvents, toggleAddMetadata: toggleAddMetadata, setActiveProp: setActiveProp, isShown: isShown, permissions: permissions, resourceType: resourceType })
                : active === "PlayerDetailsAdvancedTab" ? react_1.default.createElement(PlayerDetailsAdvancedTab_1.default, { player: player, toggle: toggle, toggleConfirmationModal: toggleConfirmationModal, permissions: permissions, resourceType: resourceType })
                    : active === "PlayerDetailsInfoTab" ? react_1.default.createElement(PlayerDetailsInfoTab_1.default, { player: player })
                        : active === "PlayerDetailsLocationTab" ? react_1.default.createElement(PlayerDetailsLocationTab_1.default, { player: player })
                            : active === "PlayerDetailsNetworkTab" ? react_1.default.createElement(PlayerDetailsNetworkTab_1.default, { player: player })
                                : active === "BlackScreenSchedule" ? react_1.default.createElement(BlackScreenSchedule_1.default, { player: player })
                                    : react_1.default.createElement(react_1.default.Fragment, null)) }));
};
exports.default = PlayerDetailsModal;
